'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../dist-es6/client/formatters');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const CustomError=require('pulsar-utils/dist-es6/customError');
const BaseController=require('../../../dist-es6/client/angularCommon/baseController');let

BaseRealtimeUpdateController=function(_BaseController){_inherits(BaseRealtimeUpdateController,_BaseController);
function BaseRealtimeUpdateController(uncaughtErrorHandler,$scope,$timeout,$interval,dateService,delayBetweenUpdates,countdownFrequency,timeZoneService){_classCallCheck(this,BaseRealtimeUpdateController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,$timeout));
_this._$scope=$scope;
_this._$timeout=$timeout;
_this._$interval=_this.preventRealtimeDigests?setInterval:$interval;
_this._clearInterval=_this.preventRealtimeDigests?clearInterval:_this._$interval.cancel;
_this._dateService=dateService;
_this._delayBetweenUpdates=delayBetweenUpdates;
_this._countdownFrequency=countdownFrequency;
_this._timeZoneService=timeZoneService;

_this._timeUntilNextUpdate=null;return _this;
}BaseRealtimeUpdateController.prototype.

_beginUpdates=function _beginUpdates(){var _this2=this;
this._checkUpdateStatus();
this._countdownCancellationToken=this._$interval(function(){return _this2._checkUpdateStatus()},this._countdownFrequency.totalMilliseconds());

this._$scope.$on('$destroy',function(){
_this2._clearInterval(_this2._countdownCancellationToken);
});
};BaseRealtimeUpdateController.prototype.





startNextUpdate=function(){var ref=_asyncToGenerator(function*(){
if(this._isUpdating){
return;
}

this._updateTimeUntilNextUpdate(null);
this.timeOfNextUpdate=null;

let completed=!1;
while(!completed){
try{
yield this._update();
this._lastUpdateTime=this._dateService.now();
completed=!0;
}catch(err){
if(err instanceof UpdateFailedError){
continue;
}
throw err;
}
}

this._updateTimeUntilNextUpdate(this._delayBetweenUpdates);
});function startNextUpdate(){return ref.apply(this,arguments)}return startNextUpdate}();BaseRealtimeUpdateController.prototype.

_updateTimeUntilNextUpdate=function(){var ref=_asyncToGenerator(function*(newValue){
this._timeUntilNextUpdate=newValue;

if(this.preventRealtimeDigests){
return;
}

return yield this._$scope.$evalAsync(_.noop);
});function _updateTimeUntilNextUpdate(newValue){return ref.apply(this,arguments)}return _updateTimeUntilNextUpdate}();BaseRealtimeUpdateController.prototype.

_checkUpdateStatus=function _checkUpdateStatus(){
if(this._isUpdating){
return;
}

this.timeOfNextUpdate=_.exists(this._lastFetchTime)?
pulsarDate(this._lastFetchTime).plus(this._delayBetweenUpdates):
this._dateService.now();

let timeUntilNextUpdate=pulsarDate(this.timeOfNextUpdate).minus(this._dateService.now());

if(timeUntilNextUpdate.totalMilliseconds()<this._countdownFrequency.totalMilliseconds()){
this.startNextUpdate();
}else
{
this._updateTimeUntilNextUpdate(timeUntilNextUpdate);
}
};BaseRealtimeUpdateController.prototype.



























_update=function(){var ref=_asyncToGenerator(function*(){
throw new Error('abstract');
});function _update(){return ref.apply(this,arguments)}return _update}();_createClass(BaseRealtimeUpdateController,[{key:'timeUntilNextUpdate',get:function(){return this._timeUntilNextUpdate}},{key:'timeOfNextUpdateString',get:function(){return this._timeOfNextUpdateString}},{key:'timeOfNextUpdate',get:function(){return this._timeOfNextUpdate},set:function(nextUpdateTime){if(this._timeOfNextUpdate&&nextUpdateTime&&this._timeOfNextUpdate.getTime()===nextUpdateTime.getTime()){return}this._timeOfNextUpdateString=nextUpdateTime!==null?'Next update at '+Formatters.timeInLocale(nextUpdateTime,this._timeZoneService.localTimeZone,!0,this.use24HourTimeline):'Updating...';this._timeOfNextUpdate=nextUpdateTime;this._$scope.$evalAsync(_.noop)}},{key:'lastUpdateTime',get:function(){return this._lastUpdateTime}},{key:'_lastFetchTime',get:function()

{
throw new Error('abstract');
}},{key:'_isUpdating',get:function()

{
throw new Error('abstract');
}}]);return BaseRealtimeUpdateController}(BaseController);let


UpdateFailedError=function(_CustomError){_inherits(UpdateFailedError,_CustomError);function UpdateFailedError(){_classCallCheck(this,UpdateFailedError);return _possibleConstructorReturn(this,_CustomError.call(this,'UpdateFailedError'))}return UpdateFailedError}(CustomError);

module.exports=BaseRealtimeUpdateController;
module.exports.UpdateFailedError=UpdateFailedError;
//# sourceMappingURL=baseRealtimeUpdateController.js.map
